(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.countdown-timer').forEach(timer => {
      const endDate = timer.dataset.endDate;
      if (!endDate) return;

      const target = new Date(endDate).getTime();
      if (isNaN(target)) return;

      const daysEl = timer.querySelector('[data-days]');
      const hoursEl = timer.querySelector('[data-hours]');
      const minutesEl = timer.querySelector('[data-minutes]');
      const secondsEl = timer.querySelector('[data-seconds]');

      const update = () => {
        const now = new Date().getTime();
        const distance = target - now;

        if (distance <= 0) {
          timer.classList.add('countdown-expired');
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      };

      update();
      setInterval(update, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-button"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const chatIcon = document.querySelector('.floating_btn');
    const textIcon = document.querySelector('.text_icon');

    // Establecer atributo de posición para estilos dinámicos
    chatIcon.setAttribute('data-position', '{{ section.settings.position }}');

    // Mostrar el mensaje después de 2 segundos
    setTimeout(function() {
      textIcon.style.display = 'block';
      textIcon.style.opacity = '1';
    }, 2000);

    // Ocultar el mensaje automáticamente después de 4 segundos adicionales
    setTimeout(function() {
      textIcon.style.opacity = '0';
      setTimeout(() => { textIcon.style.display = 'none'; }, 300); // Asegura que la transición de opacidad termine
    }, 10000);

    // Permitir que el mensaje se oculte al hacer clic
    textIcon.addEventListener('click', function() {
      textIcon.style.opacity = '0';
      setTimeout(() => { textIcon.style.display = 'none'; }, 300);
    });

    // También podrías querer ocultar el mensaje si se hace clic fuera de él
    document.addEventListener('click', function(e) {
      if (!chatIcon.contains(e.target)) {
        textIcon.style.opacity = '0';
        setTimeout(() => { textIcon.style.display = 'none'; }, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
